import React from "react";

function NA() {
    return <div>
        <h1>Where do you think you're going?</h1>
    </div>
}

export default NA;